import { ICalendarEvent } from "../../../../../../../motw_core/Calendar/ICalendarEvent";
import { CalendarEvent } from "../CalendarEventUtils/CalendarEvent";
import { HandleCurrentEvent } from "./HandleCurrentEvent";
import { HandleCurrentEventIsComplete } from "./HandleCurrentEventIsComplete";

export function ShowCurrentEventInHeader(calendarEvents: ICalendarEvent[]) {
    const currentIncompleteEvents = calendarEvents
        .map((calendarEvent) => new CalendarEvent(calendarEvent))
        .filter(
            (calendarEvent) =>
                calendarEvent.IsHappeningNow && !calendarEvent.IsCompleted
        );

    if (currentIncompleteEvents.length !== 1) {
        HandleCurrentEventIsComplete();
        return;
    }

    HandleCurrentEvent(currentIncompleteEvents);
}


